import { useQueryClient } from '@tanstack/react-query'
import * as React from 'react'

import groupService from '@/services/group.service'

import { Channel } from '@/types/group-channel.type'

export function useReorderChannels() {
  const queryClient = useQueryClient()
  const [isPending, setIsPending] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const reorderChannels = React.useCallback(
    async (channels: Channel[]) => {
      setIsPending(true)
      setError(null)
      try {
        await groupService.reorderChannels({
          channels: channels.map((ch, idx) => ({ id: ch.id, order: idx })),
        })
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: ['forum-groups'] }),
          queryClient.invalidateQueries({ queryKey: ['forum-channels'] }),
        ])
      } catch (err) {
        const msg = err instanceof Error ? err.message : 'Failed to reorder channels'
        setError(msg)
        throw err
      } finally {
        setIsPending(false)
      }
    },
    [queryClient]
  )

  return { reorderChannels, isPending, error }
}
